import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { SharedService } from '../backend-service/shared-service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  @Output() setGlobalMiFIDScope: EventEmitter<any> = new EventEmitter();

  constructor(private _sharedService: SharedService) { }

  ngOnInit() {
  }

  setINScope() {
    this._sharedService.setValue(true);
  }

  setOutScope() {
    this._sharedService.setValue(false);
  }

}
